import { createAsyncThunk } from "@reduxjs/toolkit";

import { getLiquidTemplates } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";
import { addCSPNonceToHtml } from "@/helpers/csp/add-csp-nonce-to-html";

export const fetchLiquidTemplates = createAsyncThunk(
  "liquidTemplates/fetchLiquidTemplates",
  async (params: Partial<{ config: any }>, { getState, rejectWithValue }) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl, nonce } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await getLiquidTemplates(token, baseUrl, config);

      if (nonce) {
        const updatedBodyWithNonce = (arr: Array<any>, nonce: string) => {
          return arr.map((item) => {
            if (item.body) {
              return { ...item, body: addCSPNonceToHtml(item.body, nonce) };
            }
            return item;
          });
        };

        return updatedBodyWithNonce(response, nonce);
      }

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
